import { defineMessages } from 'react-intl'

export default defineMessages({
  owner: {
    id: 'containers.EmbeddedCompanyPage.components.FinanceTerms.owner',
    defaultMessage: 'Account Owner',
  },
  ownerAlert: {
    id: 'containers.EmbeddedCompanyPage.components.FinanceTerms.ownerAlert',
    defaultMessage: 'The company has successfully been sychronized to the finance account connected to the selected company \"owner\" beneath. If you need to move the company to another finance account, please contact the VoiceArchive finance team.',
  },
  why: {
    id: 'containers.EmbeddedCompanyPage.components.FinanceTerms.why',
    defaultMessage: 'Why?',
  },
  economicDebtorGroup: {
    id: 'containers.EmbeddedCompanyPage.components.FinanceTerms.economicDebtorGroup',
    defaultMessage: 'Economic debtor group',
  },
})